module.exports = __webpack_public_path__ + "static/media/casting_eric.1a4c7ed2.jpg";